import axiosInstance from '../../../../config/axiosInstance';
const  FormService = {
    async GetAllForms(redirectCallback,ClientID,RoleID) {
        try {           
            const response = await axiosInstance.get(`/Setup/GetAllForms?ClientID=${ClientID}&RoleID=${RoleID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
};

export default FormService;